import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

const CATEGORY = 'ai outreach';

export const useAiOutreachTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const track = (action: string, eventName: string) => dispatchTrackEventWithLocation(CATEGORY, action, eventName);

  return {
    trackOpenFromOverview: (domain: string) => track('click', `open panel/overview/${domain}`),
    trackOpenFromInsights: () => track('click', 'open panel/insights'),
    trackClose: () => track('click', 'close panel'),
    trackGenerate: () => track('click', 'generate'),
    trackRetry: () => track('click', 'retry'),
    trackCopy: () => track('click', 'copy email'),
    trackFeedback: (type: 'like' | 'dislike') => track('click', `${type} output`),
    trackSendMessage: (key: string, message: string) => track('send message', `${key}/${message}`),
    trackSelectRecipient: (name: string) => track('select', `recipient/${name}`),
    trackRemoveRecipient: () => track('click', 'remove recipient'),
    trackApplyPreview: (index: number) => track('click', `apply alternative insight/${index}`),
    trackDismissAlternatives: () => track('click', 'back from alternatives'),
    trackApplyCompetitors: (count: number) => track('click', `apply competitors/${count}`),
    trackDismissCompetitorPicker: () => track('click', 'back from competitors'),
    trackAddCompetitor: (domain: string) => track('add', `competitor/${domain}`),
    trackRemoveCompetitor: (domain: string) => track('remove', `competitor/${domain}`),
  };
};
